/* eslint arrow-body-style: 0 */
import CampaignsFlowView from './components/CampaignsFlowView.vue';
import { frontendURL } from '../../../helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/campaigns_flow'),
    name: 'campaigns_flow',
    roles: ['administrator', 'agent'],
    component: CampaignsFlowView,
  }
];
